import { useNavigate } from 'react-router-dom';

import Button from '@/components/ui/buttons/Button';
import { type Student } from '@/interfaces/student';

import AbsencesFooter from '../parts/AbsencesFooter';
import AbsencesFooterContent from '../parts/AbsencesFooterContent';

import styles from './AbsencesIndexFooter.module.scss';

interface Props {
  studentId: Student['id'];
  organizationManagement?: {
    absence_time_limit?: string;
  };
}

const AbsencesIndexFooter: React.FC<Props> = ({
  studentId,
  organizationManagement,
}) => {
  const navigate = useNavigate();

  let timeLimit: string | null = null;
  if (organizationManagement?.absence_time_limit) {
    timeLimit = organizationManagement.absence_time_limit;
  }

  return (
    <AbsencesFooter sticky>
      {timeLimit && (
        <AbsencesFooterContent
          note={`当日の受付時間は${timeLimit}までです。`}
          description={`※当日、${timeLimit}以降は直接学校に問い合わせてください。`}
        />
      )}
      <Button
        color="primary"
        size="m"
        onClick={() =>
          navigate(`/absences/member/${studentId}/create`, {
            state: { timeLimit },
          })
        }
        className={styles.button}
      >
        欠席連絡
      </Button>
    </AbsencesFooter>
  );
};

export default AbsencesIndexFooter;
